<template>
  <!-- Customers whose PDF invoice or receipt goes to a placeholder address, which bounces (OC-2513). -->
  <div v-element-loader="{ endpoint: ['superuser/placeholder-pdf-emails', 'superuser/placeholder-pdf-emails/switch-off'] }">
    <div class="superuser-placeholder-pdf-emails__top">
      <p class="superuser-placeholder-pdf-emails__description">
        {{ t('superuserPlaceholderPdfEmailsDescription') }}
      </p>
      <oie-base-button
        v-if="customers && customers.length"
        css-classes="button--with-border button--blue"
        :text="t('superuserPlaceholderPdfEmailsSwitchOffAllButton')"
        @click="switchOff(null)"></oie-base-button>
    </div>

    <div class="superuser-search-result">
      <div v-if="mq('medium')" class="superuser-search-result__head">
        <div class="superuser-placeholder-pdf-emails__cell-title">
          {{ t('superuserCustomerNumberLabel') }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell-title">
          {{ t('superuserCustomerNameLabel') }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell-title">
          {{ t('superuserCustomerEmailLabel') }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell-title">
          {{ t('superuserCustomerPdfInvoiceEmailLabel') }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell-title">
          {{ t('superuserCustomerPdfReceiptEmailLabel') }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell-title">
          &nbsp;
        </div>
      </div>

      <div
        v-if="customers && customers.length === 0"
        class="superuser-search-result__body-row superuser-search-result__body-row--message">
        {{ t('superuserPlaceholderPdfEmailsNone') }}
      </div>

      <div
        v-for="customer in customers"
        :key="customer.customerNumber"
        class="superuser-placeholder-pdf-emails__body-row">
        <div class="superuser-placeholder-pdf-emails__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserCustomerNumberLabel') }}
          </div>
          {{ customer.customerNumber }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserCustomerNameLabel') }}
          </div>
          {{ customer.name }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserCustomerEmailLabel') }}
          </div>
          {{ customer.email }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserCustomerPdfInvoiceEmailLabel') }}
          </div>
          {{ customer.pdfInvoice ? customer.pdfInvoiceEmail : '' }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell">
          <div v-if="mq('to-medium')">
            {{ t('superuserCustomerPdfReceiptEmailLabel') }}
          </div>
          {{ customer.pdfReceipt ? customer.pdfReceiptEmail : '' }}
        </div>
        <div class="superuser-placeholder-pdf-emails__cell">
          <oie-base-button
            css-classes="superuser-search-results__action button--gray"
            :text="t('superuserPlaceholderPdfEmailsSwitchOffButton')"
            @click="switchOff(customer.customerNumber)"></oie-base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    customers: null,
    observer: null
  }),
  mounted() {
    // The list is a query over every customer, so it is fetched the first time the tab is shown
    // rather than whenever the super user page opens.
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.observer.disconnect()
        this.load()
      }
    })
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {
    load() {
      httpService.get('superuser/placeholder-pdf-emails').then(({ data }) => {
        this.customers = data
      })
    },
    switchOff(customerNumber) {
      const query = customerNumber ? `?customerNumber=${encodeURIComponent(customerNumber)}` : ''
      httpService.post(`superuser/placeholder-pdf-emails/switch-off${query}`).then(({ data }) => {
        this.customers = data
      })
    }
  }
}
</script>

<style lang="scss">
.superuser-placeholder-pdf-emails__top {
  display: flex;
  flex-direction: column;
  gap: measure(half);
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.superuser-placeholder-pdf-emails__description {
  max-width: 50rem;
  margin: 0;
}

.superuser-placeholder-pdf-emails__body-row {
  display: flex;
  flex-wrap: wrap;
}

.superuser-placeholder-pdf-emails__cell,
.superuser-placeholder-pdf-emails__cell-title {
  flex: 1;
  padding: 6px;
  box-sizing: border-box;
  overflow-wrap: anywhere;
}

.superuser-placeholder-pdf-emails__cell-title {
  font-weight: bold;
}
</style>
